import React, { createContext, useContext, ReactNode, useMemo } from 'react';
import { UACItem } from '../constants/UACConstants';
import { UACHelper } from '../utils/uac.utils';

interface UACContextType {
  uacHelper: UACHelper;
  uacPermissions: UACItem[];
}

const UACContext = createContext<UACContextType | undefined>(undefined);

interface UACProviderProps {
  children: ReactNode;
  uacPermissions: UACItem[];
}

export const UACProvider: React.FC<UACProviderProps> = ({ children, uacPermissions }) => {
  const uacHelper = useMemo(() => new UACHelper(uacPermissions), [uacPermissions]);

  return (
    <UACContext.Provider value={{ uacHelper, uacPermissions }}>
      {children}
    </UACContext.Provider>
  );
};

export const useUAC = (): UACContextType => {
  const context = useContext(UACContext);
  if (!context) {
    throw new Error('useUAC must be used within a UACProvider');
  }
  return context;
};

export const useUACHelper = (): UACHelper => {
  const { uacHelper } = useUAC();
  return uacHelper;
};
